import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div style={{textAlign: "center", marginTop: "50px"}}>
      <h1>HOLIDAYQR PLATFORM 🚀</h1>
      <p>Real-time travel booking coming soon...</p>
    </div>
  );
}

export default App;
